import { FunctionComponent } from 'react';

// components
import StatisticsComponent from './statistics';
import CustomerSupportComponent from './customerSupport';
import { DashboardStatistics } from '../models/AccountStatus';
import { Col, Row } from 'antd';
import SharePriceChartComponent from './sharePriceChart';
import authService from 'core/services/auth';
import useCooperative from 'core/hooks/useCooperative';

interface ActiveAccountComponentProps {
	isLoading: boolean;
	statistics: DashboardStatistics | null;
}

const ActiveAccountComponent: FunctionComponent<ActiveAccountComponentProps> = ({ isLoading, statistics }) => {
	const { isCooperative } = useCooperative();

	return (
		<>
			<div className="mt-4">
				<StatisticsComponent isLoading={isLoading} statistics={statistics} />
			</div>

			{authService.isPermittedToAction('CustomerService') && (
				<div className="mt-5">
					<Row gutter={[16, 16]}>
						<Col span={24} lg={isCooperative ? 24 : 14}>
							<CustomerSupportComponent />
						</Col>

						{!isCooperative && (
							<Col span={24} lg={authService.isPermittedToAction('CustomerService') ? 10 : 24}>
								<SharePriceChartComponent />
							</Col>
						)}
					</Row>
				</div>
			)}
		</>
	);
};

export default ActiveAccountComponent;
